import axios from "axios";
import { MessageBox, Message } from 'element-ui' // 这里我是使用elementUI的组件来给提示
// import router from '@/router'
import md5 from "crypto-js/md5";
import store from '@/store'
import UAParser from 'ua-parser-js'
const loadingInstance = null; // 加载全局的loading
// 是否显示重新登录
export const isRelogin = { show: false };
const instance = axios.create({
  // 创建axios实例，在这里可以设置请求的默认配置
  timeout: 20000, // 设置超时时间10s
  baseURL: '/api'
  // baseURL: 'http://ykb-exam-test.yikaobang.com.cn/api'
  // baseURL: "//localhost:8080/api"
});
// 文档中的统一设置post请求头。下面会说到post请求的几种'Content-Type'
instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

const httpCode = {
  // 这里我简单列出一些常见的http状态码信息，可以自己去调整配置
  400: "请求参数错误",
  401: "权限不足, 请重新登录",
  403: "服务器拒绝本次访问",
  404: "请求资源未找到",
  500: "内部服务器错误",
  501: "服务器不支持该请求中使用的方法",
  502: "网关错误",
  504: "网关超时"
};

function ksort(obj) {
  const keys = Object.keys(obj).sort();
  const sortedObj = {};
  for (const key of keys) {
    sortedObj[key] = obj[key];
  }
  return sortedObj;
}

const apiKey = "base64:f0bg5HG8T93tOFQl8BlJ9Sf+4ed918ryLaolHxRb2m4=";
const getBrowserInfo = () => {
  const parser = new UAParser()
  const result = parser.getResult()
  return `${result.browser.name}/${result.browser.version}`
}
/** 添加请求拦截器 **/
instance.interceptors.request.use(
  (config) => {
    // config.headers['token'] = sessionStorage.getItem('token') || ''
    // loadingInstance = Loading.service({
    //   spinner: "fa fa-spinner fa-spin fa-3x fa-fw",
    //   text: "拼命加载中..."
    // });
    if (config.method === "get") {
      // 添加时间戳参数，防止浏览器（IE）对get请求的缓存
      config.params = {
        ...config.params,
        t: new Date().getTime()
      };
    }
    // 签名校验
    let signData = null;
    if (config.method === "post") {
      signData = config.data;
    } else if (config.method === "get") {
      signData = config.params;
    }

    try {
      let data = ksort(signData);
      data = Object.fromEntries(
        Object.entries(data).map(([k, v]) => [k, encodeURIComponent(v)])
      );
      const sortStr = Object.entries(data)
        .map(([k, v]) => `${k}=${v}`)
        .join("&");
      const oneMd5 = md5(sortStr).toString();
      const twoMd5 = oneMd5 + apiKey;
      const sign = md5(twoMd5).toString();
      config.headers["Sign"] = sign;
      config.headers["Client-Type"] = "web";
      config.headers["Client-Model"] = getBrowserInfo();
      config.headers["uuid"] = localStorage.getItem('uuid') || '';
    } catch (error) {
      // console.log(error, "未知错误");
    }
    // 在这里：可以根据业务需求可以在发送请求之前做些什么:例如我这个是导出文件的接口，因为返回的是二进制流，所以需要设置请求响应类型为blob，就可以在此处设置。
    //   if (config.url.includes('pur/contract/export')) {
    //     config.headers['responseType'] = 'blob'
    //   }
    //   // 我这里是文件上传，发送的是二进制流，所以需要设置请求头的'Content-Type'
    //   if (config.url.includes('pur/contract/upload')) {
    //     config.headers['Content-Type'] = 'multipart/form-data'
    //   }

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

/** 添加响应拦截器  **/
instance.interceptors.response.use(
  (response) => {
    // loadingInstance.close();
    if (response.data.code === 200) {
      return Promise.resolve(response.data);
    } else if (response.data.code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true;
        MessageBox.confirm('检测到您的账号再其他设备上登录了，请重新登录', '亲爱的用户', {
          confirmButtonText: '重新登录',
          type: 'warning',
          showCancelButton: false,
          showClose: false
        }).then(() => {
          isRelogin.show = false;
          store.dispatch('loginOut').then(res => {
            location.reload()
          })
        }).catch(() => {
          isRelogin.show = false;
        });
      }
    } else if (response.data.code === 202) {
      Message({
        message: response.data.message,
        type: "error"
      });
      return Promise.resolve(response.data);
    } else {
      Message({
        message: response.data.message,
        type: "error"
      });
      return Promise.reject(response.data);
    }
  },
  (error) => {
    // console.log(error, 'error')
    // loadingInstance.close();

    if (error.response) {
      // 根据请求失败的http状态码去给用户相应的提示
      const tips =
        error.response.status in httpCode
          ? httpCode[error.response.status]
          : error.response.data.message;
      Message({
        message: tips,
        type: "error"
      });
      if (error.response.status === 401) { // token或者登陆失效情况下跳转到登录页面，根据实际情况，在这里可以根据不同的响应错误结果，做对应的事。这里我以401判断为例
        // 重新登录
        if (!isRelogin.show) {
          isRelogin.show = true;
          MessageBox.confirm('检测到您的账号再其他设备上登录了，请重新登录', '亲爱的用户', {
            confirmButtonText: '重新登录',
            type: 'warning',
            showCancelButton: false,
            showClose: false
          }).then(() => {
            isRelogin.show = false;
            store.dispatch('loginOut').then(res => {
              location.reload()
            })
          }).catch(() => {
            isRelogin.show = false;
          });
        }
      }

      return Promise.reject(error);
    } else {
      if (error.message.includes("timeout") || error.code === "ERR_NETWORK") {
        return Promise.reject('timeout');
      }
      Message({
        message: error.response.data.message,
        type: "error"
      });
      return Promise.reject(new Error("请求超时, 请刷新重试"));
    }
  }
);

/* 统一封装get请求 */
export const get = (url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    instance({
      method: "get",
      url,
      params,
      ...config
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const post = (url, data, config = {}) => {
  return instance({
    method: "post",
    url,
    data,
    ...config
  })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
